export type AdminRuntimeMapStylePresetProvider = 'local_tiles' | 'custom'

export type AdminRuntimeMapStylePreset = {
  id: string
  label: string
  provider: AdminRuntimeMapStylePresetProvider
  mapStyleUrl?: string
  localTilesBaseUrl?: string
}

export type AdminRuntimeConfig = {
  webPublicUrl?: string
  mapProvider?: 'local_tiles'
  mapStyleUrl?: string
  localTilesBaseUrl?: string
  trailTilesBaseUrl?: string
  mapOverlayTilesBaseUrl?: string
  mapStylePresets?: AdminRuntimeMapStylePreset[]
  mapDefaultStyleId?: string
  mapWorkingStyleUrl?: string
  mapWorkingEnabled?: boolean
  sentryEnabled?: boolean
  sentryDsn?: string
  sentryEnvironment?: string
  sentryRelease?: string
  sentryTracesSampleRate?: number
  googleOAuthClientId?: string
  placesAdminEnabled?: boolean
}

declare global {
  interface Window {
    __TRAILUP_ADMIN_CONFIG__?: AdminRuntimeConfig
  }
}

export function getAdminRuntimeConfig(): AdminRuntimeConfig {
  return window.__TRAILUP_ADMIN_CONFIG__ ?? {}
}

export function isPlacesAdminEnabled(): boolean {
  return getAdminRuntimeConfig().placesAdminEnabled === true
}
